export default __webpack_public_path__ + "static/grin-fc7db503d2be0bb9ad503ff0106f90c5.png";